import { observable, action } from 'mobx'

export default class ImageChallenge {
  @observable answer = ''

  constructor ({ challenge }) {
    Object.assign(this, challenge)
  }

  @action setAnswer (answer) {
    this.answer = answer
  }
}



// WEBPACK FOOTER //
// ./src/client/components/LinkAccountDialog/QuovoProvider/MultiFactorAuth/ImageChallenge/Challenge.js